export const PaymentColorPalette = {
  inputBackgroundColor: 'rgba(61, 177, 87, 0.12)',
  inputTextDisabled: '#8D8D8D',
  inputText: '#1D1D1D',
  invalidInput: '#FF3030',
  labelFocused: '#777777',
};
